import axios from "@/libs/api.request";
// 获取列表
export const getUser = params => {
  return axios.request({
    url: "/user/account",
    params,
    method: "get"
  });
};
// 创建列表
export const add = data => {
  return axios.request({
    url: "/user/account",
    data,
    method: "post"
  });
};
// 获取详情
export const getDetails = id => {
  return axios.request({
    url: `/user/account/${id}`,
    method: "GET"
  });
};
// 更新列表
export const update = data => {
  return axios.request({
    url: `/user/account/${data.id}`,
    method: "put",
    data
  });
};

// 删除列表
export const del = id => {
  return axios.request({
    url: `/user/account/${id}`,
    method: "DELETE"
  });
};
// 绑定
export const binding = data => {
  return axios.request({
    url: `/user/account/binding`,
    method: "post",
    data
  });
};
// 绑定
export const unbinding = data => {
  return axios.request({
    url: `/user/account/binding/del`,
    method: "delete",
    data
  });
};

// 更新列表
export const updatePwd = data => {
  return axios.request({
    url: "/user/account/change_password",
    method: "put",
    data
  });
};

export const exportFreight = id => {
  return axios.request({
    url: `/finance/freight/exportFreightBySale/${id}`,
    method: "get"
  });
};

export const getOperateService = () => {
  return axios.request({
    url: `/user/client/operate_service`,
    method: "get"
  });
};

export const saveBatchStatus = data => {
  return axios.request({
    url: `/user/account/batchStatus`,
    method: "post",
    data
  });
};

export const getAllService = () => {
  return axios.request({
    url: `/common/bindUser`,
    method: "get"
  });
};

export const getWaitSettlementSalesman = () => {
  return axios.request({
    url: `/common/settlement/salesman`,
    method: "get"
  });
}

export const getAllRoles = () => {
  return axios.request({
    url: `/common/role/getAllRoles`,
    method: "get"
  });
};
